import React, { useEffect, useState } from 'react';

const LOADING_MESSAGES = [
  'Analyzing damage patterns...',
  'Identifying materials needed...',
  'Checking local Greenville labor rates...',
  'Calculating estimated costs...',
  'Finalizing your quote...'
];

const LoadingOverlay: React.FC = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute inset-0 bg-surface/90 backdrop-blur-sm flex flex-col items-center justify-center z-10 p-6 text-center">
      <div className="w-16 h-16 border-4 border-brand-100 border-t-brand-500 rounded-full animate-spin mb-6"></div>
      <h3 className="text-xl font-bold text-charcoal animate-pulse">
        {LOADING_MESSAGES[messageIndex]}
      </h3>
      <p className="text-charcoal/60 mt-2 text-sm">This usually takes about 5-10 seconds</p>
    </div>
  );
};

export default LoadingOverlay;
